import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const adminNeighborhoodsSlice = (state: RootState) => state.entities.adminMarketNeighborhoods;

export const adminNeighborhoods =
  selectorsFactory.createStaticKeyWindowEntitiesMemoizedSelector(adminNeighborhoodsSlice);

export const adminNeighborhoodsState =
  selectorsFactory.createStaticKeyWindowStateMemoizedSelector(adminNeighborhoodsSlice);
